import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLoader]'
})
export class LoaderDirective {
  private hasView = false;

  @Input() set appLoader(isLoading: boolean) {
    if (isLoading && !this.hasView) {
      this.hasView = true;
      this.viewContainer.createEmbeddedView(this.loaderTemplate);
    } else if (!isLoading && this.hasView) {
      this.hasView = false;
      this.viewContainer.clear();
    }
  }

  constructor(private viewContainer: ViewContainerRef, private templateRef: TemplateRef<any>) {
    // Assign the loader template to the existing templateRef
    this.loaderTemplate = this.createLoaderTemplate();
  }

  private loaderTemplate: TemplateRef<any>;

  private createLoaderTemplate(): TemplateRef<any> {
    // Use the existing templateRef
    return this.templateRef; // Return the existing template for loader
  }
}
